import { render } from "./PlanningAccommodation.vue?vue&type=template&id=27a25a03&scoped=true"
import script from "./PlanningAccommodation.vue?vue&type=script&lang=js"
export * from "./PlanningAccommodation.vue?vue&type=script&lang=js"

import "./PlanningAccommodation.vue?vue&type=style&index=0&id=27a25a03&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27a25a03"]])

export default __exports__